import { render, staticRenderFns } from "./DevToolMoveMedia.vue?vue&type=template&id=13a9047c"
import script from "./DevToolMoveMedia.vue?vue&type=script&lang=ts"
export * from "./DevToolMoveMedia.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports